
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadCurrentProposalFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LeadCurrentProposal"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"remark"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"other"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":104}};
    doc.loc.source = {"body":"fragment LeadCurrentProposalFields on LeadCurrentProposal {\n  id\n  remark\n  cc\n  tl\n  lc\n  bg\n  other\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    



//////////////////
// WEBPACK FOOTER
// ./src/graphql/fragments/LeadCurrentProposalFragment.graphql
// module id = 518
// module chunks = 0